/*
 * The chain of events fired for a mouse click is mousedown -> blur -> mouseup -> mouseclick.
 * If an input is blurred validations may appear which can push elements on the dom below  the input down.
 * When the click occurs on an element below the input being blurred it can cause the click to end
 * on a different element the user intended. This is most obvious when clicking a submit button while focused
 * on a input with errors. In this case the submit button is pushed down the page and the click ends up
 * on a another input preventing the submit from actually being clicked.
 *
 * This module creates a set of event handlers which fire on mousedown and mouseup at the root of the document.
 * A specific component can provide it's own event handler to read these events and supprress errors
 * during a click to prevent the dom from shifting.
 *
 * Note: Event delegation is used much like React's event delegation to make sure as few events are tied
 * directly to the dom.
 *
 */
import { pull } from 'lodash';
let suppressErrorsEventHandlers = [];
export const addSuppressErrorsEventHandler = eventHandler => {
    suppressErrorsEventHandlers.push(eventHandler);
};
export const removeSuppressErrorsEventHandler = eventHandler => {
    pull(suppressErrorsEventHandlers, eventHandler);
};
const suppressNewErrors = () => suppressErrorsEventHandlers.forEach(eventHandler => eventHandler(true));
const unsuppressNewErrors = () => suppressErrorsEventHandlers.forEach(eventHandler => eventHandler(false));
if (document && document.addEventListener) {
    document.addEventListener('mousedown', suppressNewErrors, true);
    document.addEventListener('mouseup', unsuppressNewErrors, true);
}
